<template>
  <dx-modal
    id="bulk-update-modal"
    title="Atualização em massa"
    size="sm"
    :value="true"
    @input="close"
  >
    <div class="stenci-group critical">
      <div class="form-group">
        <strong>
          Atenção. Esta ação irá aplicar o valor informado a todos os registros filtrados.
        </strong>
        <div class="mt-2">
          Certifique-se de que os filtros selecionados correspondem exatamente
          aos itens que deseja atualizar.
        </div>
      </div>
      <div class="columns">
        <div class="column col-auto">
          Total de serviços:<br>
          Total atualizados:
        </div>
        <div class="column text-bold">
          {{ expenseIds.length }}<br>
          {{ filteredIds.length }}
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column col-12 form-group">
        <label class="form-label">Selecione o campo a ser atualizado</label>
        <select class="form-select"
                v-model="targetField"
                @change="newValue = targetField.value"
        >
          <option :value="targetBlank()">Selecione</option>
          <option v-for="(item, i) in fields" :value="item" :key="i">
            {{ item.name }}
          </option>
        </select>
      </div>
      <div class="column col-12 form-group" v-if="targetField?.key">
        <label class="form-label">Valor</label>
        <template v-if="targetField.type === 'number'">
          <dx-input-number
            class="form-input"
            v-model="newValue"
            maxlength="8"
            :precision="2"
          />
        </template>
        <template v-if="targetField.type === 'boolean'">
          <select class="form-select" v-model="newValue">
            <option value="false">Não</option>
            <option value="true">Sim</option>
          </select>
        </template>
        <template v-if="targetField.type === 'select'">
          <select class="form-select" v-model="newValue">
            <option v-for="(item, i) in targetField.enum"
                    :value="item.id"
                    :key="i">
              {{ item.name }}
            </option>
          </select>
        </template>
      </div>
    </div>
    <template v-slot:footer>
      <button class="btn btn-primary btn-icon btn-icon-left mr-1"
              :class="{loading: saving}"
              :disabled="saving"
              @click="save"
              v-if="targetField?.key">
        <fa-icon :icon="['fal', 'check']" />Atualizar
      </button>
      <button class="btn" @click="close">Sair</button>
    </template>
  </dx-modal>
</template>

<script>
export default {
  props: {
    tableId: {
      type: String,
      required: true,
    },
    filteredIds: {
      type: Array,
      required: true,
    },
    expenseIds: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      saving: false,
      fields: [
        {
          key: 'definition.insuranceValue',
          type: 'number',
          name: 'Campos -> Valor do plano',
          value: 0,
        },
        {
          key: 'definition.particularValue',
          type: 'number',
          name: 'Campos -> Valor paciente',
          value: 0,
        },
        {
          key: 'definition.transferValue',
          type: 'number',
          name: 'Campos -> Valor repasse',
          value: 0,
        },
        {
          key: 'definition.transferType',
          type: 'select',
          name: 'Campos -> Tipo repasse',
          enum: [
            { id: 'percent', name: '%' },
            { id: 'value', name: 'R$' },
          ],
          value: 'value',
        },
        {
          key: 'definition.taxValue',
          type: 'number',
          name: 'Campos -> Outras taxas (%)',
          value: 0,
        },
        {
          key: 'definition.secondSegment',
          type: 'number',
          name: 'Campos -> 2º segto. (%)',
          value: 0,
        },
        {
          key: 'definition.reportValue',
          type: 'number',
          name: 'Campos -> Valor assin. laudo',
          value: 0,
        },
        {
          key: 'definition.operationalCostValue',
          type: 'number',
          name: 'Campos -> Custo operacional',
          value: 0,
        },
        {
          key: 'definition.filmValue',
          type: 'number',
          name: 'Campos -> Valor m² do filme',
          value: 0,
        },
        {
          key: 'definition.filmQuantity',
          type: 'number',
          name: 'Campos -> Qtde. filme',
          value: 0,
        },
        {
          key: 'definition.feeValue',
          type: 'number',
          name: 'Campos -> Valor honorário',
          value: 0,
        },
        {
          key: 'tableCode',
          type: 'select',
          name: 'Campos -> Tabela',
          enum: [
            { id: '00', name: '00 - Tabela própria' },
            { id: '18', name: '18 - Tabela de diárias, taxas e gases' },
            { id: '19', name: '19 - Tabela de materiais e OPMEs' },
            { id: '20', name: '20 - Tabela de medicamentos' },
            { id: '22', name: '22 - Procedimentos' },
            { id: '98', name: '98 - Tabela de pacotes' },
          ],
          value: '22',
        },
        {
          key: 'definition.accredited',
          type: 'select',
          name: 'Campos -> Recebimento do honorário',
          enum: [
            { id: 'pf', name: 'Recebido pelo profissional [PF]' },
            { id: 'pj', name: 'Recebido pela clínica [PJ]' },
          ],
          value: 'pj',
        },
        {
          key: 'definition.updateValuesByCbhpm',
          type: 'boolean',
          name: 'Parâmetros -> Permitir atualizar valores via CBHPM',
          value: false,
        },
        {
          key: 'definition.priorAuthorization',
          type: 'boolean',
          name: 'Parâmetros -> Autorização prévia',
          value: false,
        },
        {
          key: 'requireAuthorization',
          type: 'boolean',
          name: 'Parâmetros -> Requer autorização do convênio',
          value: false,
        },
        {
          key: 'requireClinicalIndication',
          type: 'boolean',
          name: 'Parâmetros -> Obrigatório indicação clínica',
          value: false,
        },
        {
          key: 'requireWayTechnique',
          type: 'boolean',
          name: 'Parâmetros -> Obrigatório campos via e técnica',
          value: false,
        },
        {
          key: 'definition.insuranceTax',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Imposto do plano',
          value: false,
        },
        {
          key: 'definition.operationalCost',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Custo operacional',
          value: false,
        },
        {
          key: 'definition.film',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Filme',
          value: false,
        },
        {
          key: 'definition.interest',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Juros',
          value: false,
        },
        {
          key: 'definition.discount',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Desconto',
          value: false,
        },
        {
          key: 'definition.rate',
          type: 'boolean',
          name: 'Repassar aos profissionais -> Taxa do cartão',
          value: false,
        },
      ],
      targetField: this.targetBlank(),
      newValue: null,
    };
  },
  methods: {
    save() {
      this.$dialog.show('', {
        html:
          '<div class="text-center">'
          + '<h5 class="text-center">Atenção!</h5>'
          + '<div>Essa ação é irreversível. Deseja continuar?</div>'
          + '</div>',
        buttons: [
          {
            label: 'Não',
            classes: '',
          }, {
            label: 'Sim',
            classes: 'btn-error btn-error ml-2',
            click: (close) => {
              this.saving = true;
              close();
              const payload = {
                expenseIds: this.filteredIds,
                field: {
                  key: this.targetField.key,
                  type: this.targetField.type,
                  value: this.newValue,
                },
              };

              return this.$http.put(`/expense-tables/${this.tableId}/bulk`, payload)
                .then(() => {
                  this.$emit('saved');
                  this.$toast.success('Registro(s) atualizado(s) com sucesso!');
                })
                .catch(() => {
                  this.$toast.error('Ocorreu um erro ao salvar!');
                })
                .finally(() => {
                  this.saving = false;
                });
            },
          },
        ],
      });
    },
    close() {
      this.$emit('close');
    },
    targetBlank() {
      return {
        key: null,
        type: null,
        name: null,
        value: null,
      };
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/scss/_variables.scss';
#bulk-update-modal {
  .critical {
    border-color: $error-color;
    background-color: lighten($error-color, 25);
    margin-bottom: $layout-spacing-lg;
  }
}
</style>
